import axios from "axios";
import { GoogleGenerativeAI } from "@google/generative-ai";
import React, { useState, useEffect, useRef } from "react";
import Clipboard from "clipboard";
import alertify from "alertifyjs";

const mainPrompt =
  "أنت مستشار ذو خبرة 30 عامًا في التحليل المالي والتحقيقات المالية. خبير عالمي في الضرائب الدولية، التكنولوجيا المالية (Fintech)، العملات الرقمية، المحاسبة والتدقيق. عملت مع الحكومات، البنوك، الشركات الكبرى، وفرق مكافحة الجرائم المالية. أنت لا ترتكب أخطاء. دقتك لا تُضاهى. اكتب الرد التالي وكأن سمعتك العالمية ومصداقيتك المهنية على المحك. لا تقدم كلامًا عامًا أو غير مدعوم — فقط تحليلات دقيقة، واقعية، ومبنية على أفضل الممارسات العالمية. أجب السؤال الآتي: \n";

const OPEN_AI = process.env.REACT_APP_OPEN_AI_API_KEY;
const GEMINI_API = "AIzaSyAetO_cbRT-jKsFQEdWN4W-G5AonyU3Fgk";

const AiGemelAgent = ({ prompt }) => {
  const contentRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState([]);

  const handleAskGpt = async () => {
    setIsLoading(true);

    try {
      const apiUrl = "https://api.openai.com/v1/chat/completions";

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OPEN_AI}`, // Make sure OPEN_AI is defined
      };

      const requestBody = {
        model: "gpt-4",
        messages: [
          {
            role: "system",
            content: mainPrompt,
          },
          {
            role: "user",
            content: prompt,
          },
        ],
        max_tokens: 500, // Adjust based on your need
        temperature: 0.7, // Balance between creativity and accuracy
        top_p: 1.0,
        n: 1,
      };

      const { data } = await axios.post(apiUrl, requestBody, { headers });

      setResponse(data.choices[0].message.content);
      setIsLoading(false);
    } catch (error) {
      console.error(
        "Error sending message:",
        error.response?.data || error.message
      );
    }
  };

  const askGemini = async () => {
    // e.preventDefault();
    const genAI = new GoogleGenerativeAI(GEMINI_API);
    setIsLoading(true);
    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // You can choose other models like 'gemini-pro'

      const result = await model.generateContent(`${mainPrompt} ${prompt}`);
      console.log(result);
      const textResponse = await result.response.text();
      setResponse(textResponse.split("\n"));
    } catch (err) {
      console.error("Error calling Gemini API:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = async () => {
    const htmlContent = contentRef.current.innerHTML;

    if (typeof window.ClipboardItem === "undefined") {
      alert(
        "ClipboardItem is not supported in this environment. Try running on HTTPS or localhost."
      );
      return;
    }

    const blob = new Blob([htmlContent], { type: "text/html" });
    const data = [new window.ClipboardItem({ "text/html": blob })];

    try {
      await navigator.clipboard.write(data);
      toastrSuccess();
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const toastrSuccess = () => {
    alertify.set("notifier", "position", "top-center");
    alertify.success(" تم نسخ النص بنجاح!");
  };

  return (
    <div
      id="ai-agent"
      className="modal custom-modal fade "
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg ">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title text-primary">مساعد AI</h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div id="accordion">
              <div className="card mb-0 p-2">
                <div className="card-header bg-dark" id="headingOne">
                  <h4 className="m-0">
                    <a>خدمة مساعد AI</a>
                  </h4>
                </div>
                <div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      {!response.length > 0 ? (
                        !isLoading ? (
                          <>
                            <p>خدمة مساعد AI غير متوفرة في النسخة المجانية.</p>
                            <button
                              className="btn btn-primary"
                              onClick={askGemini}
                            >
                              سؤال مرة واحدة
                            </button>
                          </>
                        ) : (
                          <div className="col-lg-6 mt-4 " dir="ltr">
                            <div className="d-flex flex-row gap-2 bold  justify-content-center">
                              Analyzing ...
                              <div
                                className="spinner-border text-primary"
                                role="status"
                              />
                            </div>
                          </div>
                        )
                      ) : (
                        <>
                          <div ref={contentRef} dir="rtl">
                            {response.map((line, index) => (
                              <p id="paragraph-copy1" key={index} dir="rtl">
                                {line}
                              </p>
                            ))}
                          </div>
                          <button
                            className="mb-1 btn clip-btn btn-primary me-1 "
                            onClick={handleCopy}
                          >
                            <i className="far fa-copy" /> نسخ النص
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiGemelAgent;
